import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Accordion, { AccordionItem } from '@adsk/alloy-react-accordion';
import { Box, Text } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';
import { TRIAL, dayExpression } from './helpers/consts';
import { accordionItem, accordionContainer, titleText, secondaryText, labelText, footer, footerSideText, footerDateText } from './helpers/styles';
import { offeringPropType } from '../../helpers/types';
export const StyledLi = styled.li.withConfig({
  displayName: "component__StyledLi",
  componentId: "sc-pvwbfj-0"
})(secondaryText);
const SubscriptionItem = _ref => {
  let {
    subscription,
    expanded,
    onExpand
  } = _ref;
  const {
    offeringName,
    type,
    products,
    daysRemaining,
    endDate,
    sheetCount,
    alternativeSubscription
  } = subscription;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const itemTitle = /*#__PURE__*/React.createElement(Text, {
    style: titleText
  }, offeringName);
  const isTrial = type === TRIAL;
  const dayText = daysRemaining && T.translate(dayExpression(daysRemaining));
  const alternativeTrialTime = T.translate('TRIAL_EXPIRE_TIME', {
    numberOfDays: alternativeSubscription === null || alternativeSubscription === void 0 ? void 0 : alternativeSubscription.daysRemaining,
    noun: dayText
  });
  const trialTime = T.translate('TRIAL_EXPIRE_TIME', {
    numberOfDays: daysRemaining,
    noun: dayText
  });
  const subscriptionTime = endDate ? T.translate('SUBSCRIPTION_EXPIRE_TIME', {
    date: new Date(endDate).toLocaleDateString()
  }) : T.translate('SUBSCRIPTION_RENEWAL_AUTOMATICALLY');
  const sheets = sheetCount ? /*#__PURE__*/React.createElement(Text, {
    style: labelText
  }, "".concat(T.translate('SHEET_COUNT'), " ").concat(sheetCount)) : '';
  const AlternativeSpan = () => {
    if (!alternativeSubscription) return null;
    return /*#__PURE__*/React.createElement(Box, {
      style: footer,
      marginTop: "8px"
    }, /*#__PURE__*/React.createElement(Text, {
      style: footerSideText
    }, " ", T.translate('TRIAL')), /*#__PURE__*/React.createElement(Text, {
      style: footerDateText
    }, alternativeTrialTime));
  };
  const SubscriptionSpan = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      style: footerSideText
    }, " ", T.translate('SUBSCRIPTION')), /*#__PURE__*/React.createElement(Text, {
      style: footerDateText,
      "data-testid": "SubscriptionItem_TimeLabel"
    }, subscriptionTime));
  };
  const BottomSpan = () => {
    if (isTrial) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
        style: footerSideText
      }, " ", T.translate('TRIAL')), /*#__PURE__*/React.createElement(Text, {
        style: footerDateText
      }, trialTime));
    }
    return /*#__PURE__*/React.createElement(SubscriptionSpan, null);
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": subscription.offeringName
  }, /*#__PURE__*/React.createElement(Accordion, {
    "data-testid": "SubscriptionItem__Accordion",
    initialExpanded: [1],
    multiExpand: true
  }, /*#__PURE__*/React.createElement(AccordionItem, {
    "data-testid": "SubscriptionItem__AccordionItem",
    expanded: expanded,
    onExpand: onExpand,
    title: itemTitle,
    style: accordionItem,
    label: sheets
  }, (products === null || products === void 0 ? void 0 : products.length) > 0 && /*#__PURE__*/React.createElement(Box, {
    style: accordionContainer,
    "data-testid": "SubscriptionItem_AccordionContainer"
  }, /*#__PURE__*/React.createElement(Text, {
    style: secondaryText
  }, T.translate('INCLUDED_IN_SUBSCRIPTION')), /*#__PURE__*/React.createElement("ul", null, products.map(_ref3 => {
    let {
      productName,
      productKey
    } = _ref3;
    return /*#__PURE__*/React.createElement(StyledLi, {
      key: productKey
    }, productName);
  }))))), /*#__PURE__*/React.createElement(Box, {
    style: footer,
    "data-testid": "subscriptionItem"
  }, /*#__PURE__*/React.createElement(BottomSpan, null)), /*#__PURE__*/React.createElement(AlternativeSpan, null), /*#__PURE__*/React.createElement("br", null));
};
SubscriptionItem.displayName = 'SubscriptionItem';
SubscriptionItem.propTypes = {
  /**  Single user subscription and it's products*/
  subscription: offeringPropType.isRequired,
  expanded: PropTypes.bool,
  onExpand: PropTypes.func.isRequired
};
SubscriptionItem.defaultProps = {
  expanded: false
};
export default SubscriptionItem;
//# sourceMappingURL=component.js.map